import { SearchOutlined } from '@mui/icons-material';
import { CircularProgress, Box } from '@mui/material';
import searchQueryEngine from '../Core/SearchQueryEngine';
import useSearchQuery from '../useSearchQuery';
import useSearchResults from '../useSearchResults';

/**
 * Search query input — delegates all logic to SearchQueryEngine.
 * Calls its own hooks directly — no Context, no prop drilling (see Development.Patterns,
 * Feature Folder Structure rk=bb7aae5f, CalendarCard precedent: component owns the hooks it needs).
 * Escape clears query and results.
 * Enter — selects first result and moves focus to result list (via onEnter prop, local UI wiring).
 */
export default function SearchQueryInput({ onEnter }) {
    const query = useSearchQuery();
    const { loading } = useSearchResults();

    return (
        <Box className="ys-search-bar">
            <SearchOutlined sx={{ fontSize: 16, color: '#3d6a99', flexShrink: 0 }} />
            <input
                className="ys-search-input"
                value={query}
                onChange={(e) => searchQueryEngine.setQuery(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Escape') {
                        searchQueryEngine.clearQuery();
                        return;
                    }
                    // ADDED — Enter: select first result and focus result list
                    if (e.key === 'Enter' && onEnter) {
                        onEnter();
                    }
                }}
                placeholder="Search title or RK — min 3 chars"
                autoFocus
            />
            {loading && <CircularProgress size={14} sx={{ color: '#66b2ff', flexShrink: 0 }} />}
        </Box>
    );
}
